<template>
    <div v-if="page_loading">
        <loading :page_loading="page_loading" />
    </div>
    <div v-else>
      
      <v-card class="v-card-bottom-30 hidden-sm-and-up">
        <v-card-title><v-btn v-if="menuCode310 != 'null'" color="primary" to="/add-order"><v-icon>mdi-plus</v-icon></v-btn>
        </v-card-title>
      </v-card>

      <v-card class="hidden-xs-only">
        <v-card-title>
          <h4>{{use_language.order}}</h4> <v-icon>mdi-chevron-right</v-icon><span class="font-weight-regular body-1">{{use_language.my_order}}</span>
          <v-spacer/>
          <v-btn v-if="menuCode310 != 'null'" color="primary" to="/add-order"><v-icon>mdi-plus</v-icon></v-btn>
        </v-card-title>
      </v-card>

      <!-- announce -->
      <v-card elevation="1" class="v-card-margin-bottom-30" v-if="announceDataTable.length != 0">
        <v-card-title>
          <v-icon size="22" color="primary">fa-bullhorn</v-icon>
          <span class="ml-3">{{use_language.announcement}}</span>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="announceHeaders"
            :items="announceDataTable"
            class="elevation-0 packhai-border-table"
            hide-default-footer
            style="min-height: auto"
            :items-per-page="9999999999"
            :mobile-breakpoint="0"
          >
            <template v-slot:item.startDate="{ item }">
              <span>{{item.startDate}} - {{item.endDate}}</span>
            </template>
            <template v-slot:item.photoLink="{ item }">
              <v-img 
                v-if="item.photoLink != null" 
                class="my-1 justify-center" 
                max-width="80px" 
                :src="item.photoLink" 
                @click="image_click(item.photoLink)"
              />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-progress-linear
        color="red" class="mt-4"
        
        :indeterminate="loading_data"
      ></v-progress-linear>
      <v-card  >
        <v-card-text>
          <v-row>
            <v-col class="pa-0" cols="12" md="6" lg="2">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-select
                    :value="SHselectStatus"
                    @change="value => SHselectStatus = value"
                    autocomplete="off"
                    :items="SHitemsStatus"
                    item-key="text"
                    item-value="value"
                    :label="use_language.order_status"
                    hide-details
                    dense
                    outlined
                  >
                    <template v-slot:label> <span>{{use_language.order_status}}</span> </template> </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-select
                        :value="select_search_parcel_status_id"
                        @change="value => select_search_parcel_status_id = value"
                        autocomplete="off"
                        :items="search_parcel_status_list"
                        item-text="text"
                        item-value="value"
                        outlined
                        hide-details
                        dense
                        :label="use_language.parcel_delivery_status"
                      >
                      <template v-slot:label> <span>{{use_language.parcel_delivery_status}}</span> </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-select
                      :value="select_search_paid_status_id"
                      @change="value => select_search_paid_status_id = value"
                      autocomplete="off"
                      :items="search_paid_status_list"
                      item-text="text"
                      item-value="value"
                      outlined
                      hide-details
                      dense
                      :label="use_language.cod_pay_status"
                    >
                    <template v-slot:label> <span>{{use_language.cod_pay_status}}</span> </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-0" cols="12" md="6" lg="3">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-menu
                    ref="search_menu_date_range"
                    v-model="search_menu_date_range"
                    :close-on-content-click="false"
                    :return-value.sync="search_date_range"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          :value="computed_search_date"
                          @change="value => computed_search_date = value"
                          autocomplete="off"
                          :label="use_language.open_order_date"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          ref="dateRangeText"
                          outlined readonly
                          hide-details
                          dense
                          v-on="on"
                      >
                        <template v-slot:label> <span>{{use_language.open_order_date}}</span> </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="search_date_range" range no-title scrollable :allowed-dates="allowedDates" class="my-0">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="search_date_range = []">{{use_language.reset}}</v-btn>
                      <v-btn text color="primary" @click="search_menu_date_range = false">{{use_language.cancel_1}}</v-btn>
                      <v-btn text color="primary" @click="$refs.search_menu_date_range.save(search_date_range)">{{use_language.ok}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-menu
                      ref="menu_search_sent_date"
                      v-model="menu_search_sent_date"
                      :close-on-content-click="false"
                      :return-value.sync="sent_date_range"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computed_search_sent_date"
                          @change="value => computed_search_sent_date = value"
                          autocomplete="off"
                          :label="use_language.delivery_date"
                          outlined
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          dense
                          v-on="on"
                        >
                          <template v-slot:label> <span>{{use_language.delivery_date}}</span> </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="sent_date_range" range no-title :allowed-dates="allowedDates" class="my-0">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="sent_date_range = []">{{use_language.reset}}</v-btn>
                        <v-btn text color="primary" @click="menu_search_sent_date = false">{{use_language.cancel_1}}</v-btn>
                        <v-btn text color="primary" @click="$refs.menu_search_sent_date.save(sent_date_range)">{{use_language.ok}}</v-btn>
                      </v-date-picker>
                    </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-menu
                    ref="menu_search_tranferred_date"
                    v-model="menu_search_tranferred_date"
                    :close-on-content-click="false"
                    :return-value.sync="packed_date_range"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computed_search_tranferred_date"
                        @change="value => computed_search_tranferred_date = value"
                        autocomplete="off"
                        :label="use_language.pack_date"
                        outlined
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      >
                  <template v-slot:label> <span>{{use_language.pack_date}}</span> </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="packed_date_range" range no-title :allowed-dates="allowedDates" class="my-0">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="packed_date_range = []">{{use_language.reset}}</v-btn>
                      <v-btn text color="primary" @click="menu_search_tranferred_date = false">{{use_language.cancel_1}}</v-btn>
                      <v-btn text color="primary" @click="$refs.menu_search_tranferred_date.save(packed_date_range)">{{use_language.ok}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>


            
            <v-col class="pa-0" cols="12" md="6" lg="2">
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-text-field
                    :value="SHorderID"
                    @change="value => SHorderID = value"
                    autocomplete="off"
                    :label="use_language.order_number"
                    outlined
                    hide-details
                    dense
                  >
                    <template v-slot:label> <span>{{use_language.order_number}}</span> </template>
                  </v-text-field>
                </v-col> 
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-text-field
                      :value="SH_ReferenceNumber"
                      @change="value => SH_ReferenceNumber = value"
                      autocomplete="off"
                      :label="use_language.reference_number"
                      outlined
                      hide-details
                      dense
                    >
                    <template v-slot:label> <span>{{use_language.reference_number}}</span> </template>
                  </v-text-field>
                </v-col> 
              </v-row>
               <v-row>
                <v-col cols="12"  class="pb-0">
                   <v-select
                      v-model="channelListSeleced"
                      :items="channelList" 
                      :label="use_language.channel"
                      multiple 
                      item-value="uniqueID"
                      item-text="name"
                      return-object
                      hide-details
                      dense
                      clearable
                      outlined
                    >
                      <template v-slot:item="{item}">
                        <v-icon 
                            v-if="channelListSeleced !== null && channelListSeleced.includes(item)" 
                            color="primary" 
                            class="mr-3">
                            mdi-checkbox-marked
                        </v-icon>
                        <v-icon v-else class="mr-3">
                            mdi-checkbox-blank-outline
                        </v-icon>
                        <img :src="item.logo" width="20px;"/> 
                        <div class="ml-2">{{item.name}} </div> 
                    </template>
                    <template v-slot:selection="{ item }">
                      {{item.name}}
                    </template>
                  </v-select>
                </v-col> 
              </v-row>
            </v-col>
            <v-col class="pa-0" cols="12" md="6" lg="2">
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-text-field
                    :value="SHshipName"
                    @change="value => SHshipName = value"
                    autocomplete="off"
                    :label="use_language.recipient_name"
                    hide-details
                    dense
                    outlined
                  >
                  <template v-slot:label> <span>{{use_language.recipient_name}}</span> </template>
                  </v-text-field>
                </v-col> 
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-text-field
                    :value="SHtrackingNo"
                    @change="value => SHtrackingNo = value"
                    autocomplete="off"
                    :label="use_language.tracking_no"
                    hide-details
                    dense
                    outlined
                  >
                  <template v-slot:label> <span>{{use_language.tracking_no}}</span> </template>
                  </v-text-field>
                </v-col> 
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-combobox
                    v-model="SH_shop_staff"
                    :items="SH_shop_staff_items"
                    :label="use_language.create_by"
                    item-key="text"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  >
                  <template v-slot:label> <span>{{use_language.create_by}}</span> </template>
                  </v-combobox>
                </v-col> 
              </v-row>
            </v-col>
             <v-col class="pa-0" cols="12" md="6" lg="3">
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-text-field
                    :value="SH_phone"
                    @change="value => SH_phone = value"
                    autocomplete="off"
                    :label="use_language.tel"
                    outlined
                    hide-details
                    dense
                  >
                  <template v-slot:label> <span>{{use_language.tel}}</span> </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-2 pt-5">
                  <!-- ประเภทออเดอร์: ปัจจุบัน / จัดเก็บ — สลับ endpoint + หน้า detail ด้วย isArchiveMode -->
                  <v-radio-group v-model="isArchiveMode" row hide-details class="mt-0"  @change="onOrderTypeChange">
                    <v-radio :label="use_language.current_orders" :value="false"></v-radio>
                    <v-radio :label="use_language.archived_orders" :value="true"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  class="pb-0">
                  <v-btn @click="Searching()" :loading="loading_data" color="primary" class="mr-3">{{use_language.search}}</v-btn>
                    <v-btn :loading="loadingBtnExcel" :elevation="1" outlined color="success"  @click="getExcelHeaderList">
                      <v-icon size="14" class="pr-1">fa-solid fa-download</v-icon>
                      <span class="fn-12"> Excel </span>
                      <span v-if="loadingExcel != 0">({{ loadingExcel }}%)</span>
                    </v-btn>
                </v-col> 
              </v-row>
               
            </v-col>
          </v-row>
        
          
       
        </v-card-text>
      </v-card>

      <v-row  >
        <v-col cols="6" align="left" class="px-0">
          <!-- Bulk print actions are hidden in archive mode (read-only browsing). -->
          <v-menu offset-y v-if="!isArchiveMode">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="!authorize"  outlined v-bind="attrs" v-on="on" class="mr-1 pa-2">
                <span class="pl-2">{{use_language.carry_out}}</span>
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="inv_pre_print()">
                <v-list-item-title>{{use_language.print_document}}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="cover_pages()">
                <v-list-item-title>{{use_language.print_cover_sheet}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="6" align="right" class="px-0">
           
          <!--  -->
          <v-btn v-show="IsHeaderShot == false"  color="" class="pa-2  mt-1"  icon  @click="IsHeaderShot = true">
               <v-icon  size="16" class="pr-1">fa-list</v-icon>
          </v-btn>
          <v-btn  v-show="IsHeaderShot == true" color="" class="pa-2  mt-1"  icon @click="IsHeaderShot = false">
                <v-icon size="16" class="pr-1">fa-table</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- status tabs ใช้กับออเดอร์ปัจจุบันเท่านั้น — โหมดจัดเก็บซ่อนทั้งการ์ด (ไม่ให้เหลือแถบว่างข้างหน้า) -->
      <v-card v-if="!isArchiveMode">
        <v-tabs class="box-shadow" v-model="tab_list"  show-arrows>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab @click="tab_list = 0, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(0)">{{use_language.all_}} <span v-if="IsSearch == false">({{ this.summary_shipping_status.SumAllShippingStatus }})</span> <span v-else>({{this.total_search_data_order_master}})</span> </v-tab>
          <v-tab @click="tab_list = 1, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['OpenOrder'])">{{use_language.open_order}} ({{summary_shipping_status.OpenOrder}})</v-tab>
          <v-tab @click="tab_list = 2, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['WaitCheck'])">{{use_language.waiting_check_balance}} ({{summary_shipping_status.WaitCheck}})</v-tab>
          <v-tab @click="tab_list = 3, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['WaitPack'])">{{use_language.wati_pack}} ({{summary_shipping_status.WaitPack}})</v-tab>
          <v-tab @click="tab_list = 4, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['Packing'])">{{use_language.packing}} ({{summary_shipping_status.Packing}})</v-tab>
          <v-tab @click="tab_list = 5, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['Packed'])">{{use_language.neatly_packed}} ({{summary_shipping_status.Packed}})</v-tab>
          <v-tab @click="tab_list = 6, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['Ready'])">{{use_language.prepare_ship}} ({{summary_shipping_status.Ready}})</v-tab>
          <v-tab @click="tab_list = 7, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['Sent'])">{{use_language.shipped}} ({{summary_shipping_status.Sent}})</v-tab>
          <v-tab @click="tab_list = 8, IsSearch = false, isArchiveMode = false, offsets = 0, select_shipping_status_button(shippingStatusDict['Cancel'])">{{use_language.cancel}} ({{summary_shipping_status.Cancel}})</v-tab>
        </v-tabs>
      </v-card>
      <!-- แสดงจอใหญ่ -->

      <v-tabs-items v-model="tab_list" class="hidden-xs-only" touchless>
        <v-tab-item v-for="j in 10" :key="j" style=" background-color: #F2F4F8">
          <div flat >
            <v-data-table
              v-if="IsHeaderShot == false"
              :headers="headersShow"
              :items="showdataTable"
              class="elevation-0 packhai-border-table"
              v-model="selected_order"
              :single-select="singleSelect"
              item-key="id"
              :show-select="!isArchiveMode"
              hide-default-footer
              :items-per-page="10000">
              <template v-slot:item.num="{ item }">
                {{ gen_num_data_table(showdataTable.indexOf(item)) }}
              </template>
              <template v-slot:item.id="{ item }">
                <v-btn style="text-decoration: underline" color="primary" text @click="isArchiveMode ? archive_detail_page(item.id) : detail_page(item.id)">{{ format_order_id(item.id) }}</v-btn><br><span v-if="item.isPreOrder == 1" class="text-info"><b>{{use_language.pre_order}}</b></span>
              </template>
              <template v-slot:item.channelLogo="{ item }">
                  <v-avatar size="25px">
                    <img :src="item.channelLogo" @click="image_click(item.channelLogo)"/>
                  </v-avatar>
              </template>
              <template v-slot:item.expressCompanyLogo="{ item }">
                  <!-- <v-avatar size="25px"> -->
                    <img style="width: 60px" :src="item.expressCompanyLogo" @click="image_click(item.expressCompanyLogo)"/>
                  <!-- </v-avatar> -->
              </template>
              <template v-slot:item.createdDatetime="{ item }">
                {{ set_format_date_time(item.createdDatetime) }}
              </template>
              <template v-slot:item.receiverName="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div  v-bind="attrs"  v-on="on" style="width: 250px" class="text-truncate">
                      <span v-if=" item.receiverName != null">{{ item.receiverName }}</span>
                      <span v-else>{{ item.tempAddress }}</span>
                    </div>

                  </template>
                  <span>
                    <span v-if=" item.receiverName != null">{{ item.receiverName }}</span>
                    <span v-else>{{ item.tempAddress }}</span>
                  </span>
                </v-tooltip>


              </template>
              <template v-slot:item.orderTotalAmount="{ item }">
                {{ format_price( item.orderTotalAmount ) }}
              </template>
              <template v-slot:item.createdByStaffName="{ item }">
                {{ item.createdByStaffShopName }}
              </template>
              <template v-slot:item.salemanName="{ item }">
                {{ item.salemanName }}
              </template>
              <template v-slot:item.isCod="{ item }">
                <span v-if="item.isCOD == false"><v-chip color="#0951e5" outlined>{{use_language.ordinary}}</v-chip></span> <span v-else ><v-chip color="primary" style="width: 70px; padding-left: 20px" dark>{{use_language.cod}}</v-chip></span>
              </template>
             
              <template v-slot:item.referenceNumber="{ item }">
                <span v-if="item.referenceSourceID == 6">
                  {{item.realReferenceNumber}}
                </span>
                <span v-else>
                  {{ item.referenceNumber}}
                </span>
              </template>
              <template v-slot:item.shippingStatusName="{ item }">
                <span v-if="item.shippingStatusID == 10" style="color: black;">{{ use_language.open_order }}</span>
                <span v-if="item.shippingStatusID == 20" style="color: #E40078;">{{ use_language.waiting_check_balance }}</span>
                <span v-if="item.shippingStatusID == 30" style="color: #ff7ac0;">{{ use_language.wati_pack }}</span>
                <span v-if="item.shippingStatusID == 40" style="color: orange;">{{ use_language.packing }}</span>
                <span v-if="item.shippingStatusID == 50" style="color: blue;">{{ use_language.neatly_packed }}</span>
                <span v-if="item.shippingStatusID == 60" style="color: #9acd32;">{{ use_language.prepare_ship }}</span>
                <span v-if="item.shippingStatusID == 70" style="color: green;">{{ use_language.shipped }}</span>
                <span v-if="item.shippingStatusID == 90" style="color: red;">{{ use_language.cancel }}</span>
              </template>
              <template v-slot:item.parcelStatusName="{ item }">
                <span v-if="item.parcelStatusID == 0" style="color: purple;">{{ use_language.order_tab_count_wait_pickup }}</span>
                <span v-else-if="item.parcelStatusID == 1" style="color: orange;">{{ use_language.order_tab_count_delivering }}</span>
                <span v-else-if="item.parcelStatusID == 2" style="color: red;">{{ use_language.order_tab_count_returning }}</span>
                <span v-else-if="item.parcelStatusID == 3" style="color: #ff7ac0 ;">{{ use_language.bounce + ', ' + use_language.order_tab_count_to_return_stock }}</span>
                <span v-else-if="item.parcelStatusID == 4" style="color: #ff7ac0;">{{ use_language.bounce + ', ' +	use_language.order_tab_count_stock_returned }}</span>
                <span v-else-if="item.parcelStatusID == 5" style="color:green;">{{ use_language.successful_delivery }}</span>
                <span v-else-if="item.parcelStatusID == 6" style="color:red;">{{ use_language.cancel }}</span>
                <span v-else>{{ item.parcelStatusName }}</span>
              </template>
            </v-data-table>
            <div v-else class="my-2" v-for="item in showdataTable" :key="item.id">
              <v-card>
                <v-card-text class="py-2">
                  <v-row>
                    <v-col>
                      <table style="width:100%">
                        <td style="width:80px; vertical-align:middle" >
                          <a style="color: red" @click="isArchiveMode ? archive_detail_page(item.id) : detail_page(item.id)"><b><u>{{ format_order_id(item.id) }}</u></b> </a>
                        </td>
                        <td style="border-left: 2px solid #f0f0f0;" v-if="item.referenceNumber != null">
                          <span class="pl-5"  > {{use_language.reference_number}} :  <span style="color: black"> {{ item.referenceNumber }}</span></span>
                        </td>
                        <td class="text-right">
                          <span style="color: black" >{{ set_format_date_time( item.createdDatetime) }}</span>
                        </td>
                      </table>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col class="pt-1" cols="2" md="2" lg="2" xl="1" style="border-right: 1px solid #EEEEEE;">
                      <a style="color: red" @click="detail_page(item.token)"><b><u>{{ format_order_id(item.id) }}</u></b> </a>
                    </v-col>
                    <v-col class="pt-1" cols="5" md="5" lg="5" xl="5">
                      <span v-if="item.referenceNumber != null" > {{ use_language.reference_number }} :  <span style="color: black"> {{ item.referenceNumber }}</span></span>
                    </v-col>
                    <v-col class="pt-1" cols="5" md="5" lg="5" xl="6" align="right">
                      <span style="color: black" >{{ set_format_date_time( item.createdDatetime) }}</span>
                    </v-col>
                  </v-row> -->
                  <v-divider/>
                    <v-row>
                      <v-col class="py-2" cols="3">
                        <span> {{use_language.customer}} : </span><br>
                        <span v-if="item.receiverName != null" style="color: black"> {{ item.receiverName }} </span>
                        <span v-else style="color: black">  {{ item.tempAddress }}</span>
                      </v-col>
                      <v-col class="py-2" cols="3">
                        <span> {{use_language.sales}} : </span><br>
                        <span style="color: black"> {{ format_price( item.orderTotalAmount) }} </span><br>
                        <span v-if="item.isCOD" ><v-icon style="font-size:6px" color="red">fa fa-circle</v-icon> <span style="color: black" ><b>COD</b></span>  </span>
                        <!-- <span v-else><v-icon style="font-size:6px" color="blue">fa fa-circle</v-icon> ธรรมดา</span> -->
                      </v-col>
                      <v-col class="py-2" cols="3">
                        <span> {{use_language.order_status_}} : </span><br>
                          <span v-if="item.shippingStatusID == 10" style="color: black;">{{ use_language.open_order }}</span>
                          <span v-if="item.shippingStatusID == 20" style="color: #E40078;">{{ use_language.waiting_check_balance }}</span>
                          <span v-if="item.shippingStatusID == 30" style="color: #ff7ac0;">{{ use_language.wati_pack }}</span>
                          <span v-if="item.shippingStatusID == 40" style="color: orange;">{{ use_language.packing }}</span>
                          <span v-if="item.shippingStatusID == 50" style="color: blue;">{{ use_language.neatly_packed }}</span>
                          <span v-if="item.shippingStatusID == 60" style="color: #9acd32;">{{ use_language.prepare_ship }}</span>
                          <span v-if="item.shippingStatusID == 70" style="color: green;">{{ use_language.shipped }}</span>
                          <span v-if="item.shippingStatusID == 90" style="color: red;">{{ use_language.cancel }}</span>
                      </v-col>
                      <v-col class="py-2" cols="3">
                        <span><img style="width: 50px" :src="item.expressCompanyLogo" @click="image_click(item.expressCompanyLogo)"/></span><br>
                        <span v-if="item.trackingNo != null" > TrackingNo : <span style="color: black"> {{ item.trackingNo }}</span>  </span><br>
                        <span v-if="item.parcelStatusID != null"> {{use_language.status}} :
                            <span v-if="item.parcelStatusID == 0" style="color: purple;">{{ use_language.order_tab_count_wait_pickup }}</span>
                            <span v-else-if="item.parcelStatusID == 1" style="color: orange;">{{ use_language.order_tab_count_delivering }}</span>
                            <span v-else-if="item.parcelStatusID == 2" style="color: red;">{{ use_language.order_tab_count_returning }}</span>
                            <span v-else-if="item.parcelStatusID == 3" style="color: #ff7ac0 ;">{{ use_language.bounce + ', ' + use_language.order_tab_count_to_return_stock }}</span>
                            <span v-else-if="item.parcelStatusID == 4" style="color: #ff7ac0;">{{ use_language.bounce + ', ' +	use_language.order_tab_count_stock_returned }}</span>
                            <span v-else-if="item.parcelStatusID == 5" style="color:green;">{{ use_language.successful_delivery }}</span>
                            <span v-else-if="item.parcelStatusID == 6" style="color:red;">{{ use_language.cancel }}</span>
                            <span v-else>{{ item.parcelStatusName }}</span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-1 pb-0" cols="12">
                        <table style="width:100%">
                          <td style="width:60px; vertical-align:middle" >
                            <span class="pb-5">{{use_language.channel}} : </span>
                          </td>
                          <td>
                            <img style="width: 20px" :src="item.channelLogo" @click="image_click(item.channelLogo)"/>
                          </td>
                          <td class="text-right">
                              <span>{{use_language.create_by}} : <span style="color: black">{{ item.createdByStaffShopName }} </span>    , {{use_language.salesperson}} : <span style="color: black">  {{ item.salemanName }}</span></span>
                          </td>
                        </table>
                      </v-col>
                    </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>

      <!-- new table tab end -->



      <!-- แสดงจอมือถือ -->
      <v-row class="hidden-sm-and-up mx-0" align="center">

        <v-col cols="12" class="pa-0">
          <v-card v-for="(item, index) in showdataTable" :key="index" style="border-radius :0px;" class="my-3" elevation="0" @click="isArchiveMode ? archive_detail_page(item.id) : detail_page(item.id)">
            <v-row class="px-3 fz-14 mx-0 pb-2">
              <v-col cols="6" align="left" class="pt-4"><span style="color: red;"><b> <u>{{ format_order_id(item.id) }}</u></b></span><span v-if="item.isPreOrder == 1" class="text-info"><b>{{use_language.pre_order}}</b></span> </v-col>
              <v-col cols="6" align="right">
                <!-- <span v-if="item.isCOD == false"><v-chip color="#0951e5" outlined>{{use_language.ordinary}}</v-chip></span> <span v-else ><v-chip color="primary" style="width: 70px; padding-left: 20px" dark>{{use_language.cod}}</v-chip></span> -->
                <span v-if="item.shippingStatusID == 10" style="color: black;">{{ use_language.open_order }}</span>
                <span v-if="item.shippingStatusID == 20" style="color: #E40078;">{{ use_language.waiting_check_balance }}</span>
                <span v-if="item.shippingStatusID == 30" style="color: #ff7ac0;">{{ use_language.wati_pack }}</span>
                <span v-if="item.shippingStatusID == 40" style="color: orange;">{{ use_language.packing }}</span>
                <span v-if="item.shippingStatusID == 50" style="color: blue;">{{ use_language.neatly_packed }}</span>
                <span v-if="item.shippingStatusID == 60" style="color: #9acd32;">{{ use_language.prepare_ship }}</span>
                <span v-if="item.shippingStatusID == 70" style="color: green;">{{ use_language.shipped }}</span>
                <span v-if="item.shippingStatusID == 90" style="color: red;">{{ use_language.cancel }}</span>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="px-3 mx-0 py-3">
              <v-col cols="6" align="left"><span>{{use_language.create_date}}</span><br>
                <span class="fz-12"> <b> {{ set_format_date_time(item.createdDatetime) }} </b> </span>
              </v-col>
              <v-col cols="6" align="right">
                <img style="width: 30px" :src="item.channelLogo" @click="image_click(item.channelLogo)"/>
              </v-col>
            </v-row>
            <v-row class="px-3 mx-0">
              <v-col cols="12" align="center" class="py-3">
                <span>{{use_language.sales}}</span><br>
                <span style="font-size: 24px; font-weight: bold; color: brack;" >{{ format_price(item.orderTotalAmount) }} ฿</span> <br>
                <span v-if="item.isCOD"><v-icon style="font-size:6px" color="red">fa fa-circle</v-icon> COD</span>
                <!-- <span v-else><v-icon style="font-size:6px" color="blue">fa fa-circle</v-icon> ธรรมดา</span> -->
              </v-col>
            </v-row>
            <v-row class="px-3 mx-0 fz-14">
              <v-col cols="12" align="left" class="py-0 pt-2">
                <span>{{use_language.recipient_name}} : </span> <span v-if="item.referenceNumber == null"><b> {{ item.receiverName }}</b></span>
                <span v-else><b> {{ item.tempAddress }}</b></span>
              </v-col>
              <v-col cols="12" align="left" class="pt-0 pb-2">
                <span>{{use_language.create_by}} : </span><span><b>{{ item.createdByStaffShopName }}</b></span>
              </v-col>
              <v-col cols="12" align="left" class="pt-0 pb-2">
                <span>{{use_language.salesperson}} : </span><span><b>{{ item.salemanName }}</b></span>
              </v-col>
              <v-col cols="12" align="left" class="pt-0 pb-2">
                <span>{{use_language.transport}} : </span>
                <img style="width: 70px" :src="item.expressCompanyLogo" @click="image_click(item.expressCompanyLogo)"/>
              </v-col>
            </v-row>
            <v-divider v-if="item.trackingNo != null"></v-divider>
            <v-row v-if="item.trackingNo != null" class="px-3 mx-0 fz-14">
              <v-col cols="8" align="left" class="pt-4">
                <span>{{use_language.tracking_no}} : </span> <span><b> {{ item.trackingNo }}</b></span>

              </v-col>
              <v-col cols="4" align="right" >
                <span v-if="item.parcelStatusID == 0" style="color: purple;">{{ use_language.order_tab_count_wait_pickup }}</span>
                <span v-else-if="item.parcelStatusID == 1" style="color: orange;">{{ use_language.order_tab_count_delivering }}</span>
                <span v-else-if="item.parcelStatusID == 2" style="color: red;">{{ use_language.order_tab_count_returning }}</span>
                <span v-else-if="item.parcelStatusID == 3" style="color: #ff7ac0 ;">{{ use_language.bounce + ', ' + use_language.order_tab_count_to_return_stock }}</span>
                <span v-else-if="item.parcelStatusID == 4" style="color: #ff7ac0;">{{ use_language.bounce + ', ' +	use_language.order_tab_count_stock_returned }}</span>
                <span v-else-if="item.parcelStatusID == 5" style="color:green;">{{ use_language.successful_delivery }}</span>
                <span v-else-if="item.parcelStatusID == 6" style="color:red;">{{ use_language.cancel }}</span>
                <span v-else>{{ item.parcelStatusName }}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row  class="mx-0">
        <v-col cols="12" align="center">
          <div class="text-center" @click="changePage()">
            <v-pagination
              v-model="page"
              :length="pageLength"
              :total-visible="7"
              color="primary"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog_excel" scrollable max-width="500px" persistent >
        <v-card elevation="1" class="ma-0">
          <v-card-title >
            <span >{{use_language.export_excel}}</span>
            <v-spacer></v-spacer>
            <v-btn icon style="color: red;" @click="dialog_excel = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text >
            <v-row style="align-items: center">
              <v-col cols="12" md="3" lg="3" class="py-0">{{use_language.choose}}</v-col>
              <v-col cols="11" md="8" lg="8" class="py-0 pr-0">
                <v-combobox
                  v-model="excelHeaderChoose"
                  :items="excelHeaderChoiceList"
                  label="template"
                  item-key="templateName"
                  item-value="id"
                  outlined
                  hide-details
                  dense
                >
                </v-combobox>
              </v-col>
              <v-col cols="1" class="py-0">
                <a @click="goToHeaderSetting">
                  <v-icon size="20">fa-cog</v-icon>
                </a>
              </v-col>
            </v-row>
            <v-divider class="mt-4"/>
            <v-row>
              <v-col>
                <v-checkbox v-model="IsSkipSecondRow" :label="use_language.fill_all_rows_if_multiple_products"/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" align="right">
                <v-btn color="primary" @click="get_order_export_excel(), dialog_excel= false">{{use_language.carry_out}} </v-btn> 
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog  v-model="inv_dialog_printinvoice" scrollable persistent max-width="45%" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
          <v-card-title>
            <span > {{use_language.print_document}} </span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="inv_dialog_printinvoice=false" > <v-icon>mdi-close</v-icon> </v-btn></v-card-title>
          <v-card-text>
            <v-row row align="center">
              <v-col class="pb-0" cols="12" md="3">
                <h4>{{use_language.section}} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="4">
                <v-select
                  ref="refinvtitleprintmain"
                  v-model="invoice_print.titleprint_main"
                  autocomplete="off"
                  :items="inv_titleprintselect"
                  item-text="text"
                  item-value="value"
                  :label="use_language.choose_topic"
                  return-object
                  dense
                  hide-details
                  outlined
                  />
                     <template v-slot:label> <span>{{use_language.choose_topic}}</span> </template>

              </v-col>
              <v-col class="pb-0" cols="12" md="1">
                <h1 class="text-center">/</h1>
              </v-col>
              <v-col class="pb-0" cols="12" md="4">
                <v-select
                  ref="refinvtitleprintsecondary"
                  v-model="invoice_print.titleprint_secondary"
                  autocomplete="off"
                  :items="inv_titleprintselect"
                  item-text="text"
                  item-value="value"
                  :label="use_language.choose_topic"
                  return-object
                  dense
                  hide-details
                  outlined
                  />
                  <template v-slot:label> <span>{{use_language.choose_topic}}</span> </template>

              </v-col>
            </v-row>
            <!-- <v-row row >
              <v-col class="pb-0" cols="12" md="3">
                <h4>{{ use_language.date }} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="9">
                <v-menu
                  ref="inv_menu_date_print"
                  v-model="inv_menu_date_print"
                  :close-on-content-click="false"
                  :return-value.sync="invoice_print.printorder[0].invorder.date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        ref="refdate"
                        :value="invoice_print.printorder[0].date"
                        @change="value => computed_date_print = value"
                        autocomplete="off"
                        outlined
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        dense
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="invoice_print.printorder[0].date"
                    @input="inv_menu_date_print = false,
                    $refs.inv_menu_date_print.save(invoice_print.printorder[0].date)"
                    no-title :allowed-dates="allowedDates" class="my-0">
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row> -->
            <v-row row>
              <v-col class="pb-0" cols="12" md="3">
                <h4>{{use_language.choose_document_size}} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="9">
                <v-radio-group v-model="sizepage" row>
                  <v-radio :label="use_language.size_a4" value= "a4" ></v-radio>
                  <v-radio :label="use_language.size_80_mm" value= "small"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row row >
              <v-col class="pb-0" cols="12" md="3">
                <h4>{{use_language.document_number}} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="9">
                <v-data-table
                    :headers="invorderhead"
                    :items="invoice_print.invorder"
                    class="elevation-0 packhai-border-table"
                    hide-default-footer
                    :items-per-page="50">
                    <template v-slot:item.orderid="{ item }">{{format_order_id(item.orderId)}}</template>
                    <template v-slot:item.dateString="{ item }">
                      <v-menu
                          ref="startDateMenu"
                          v-model="item.startDateMenu"
                          :close-on-content-click="true" 
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="item.dateString"
                              @change="value => item.date = value"
                              autocomplete="off"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              dense
                              hide-details
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.date"
                            @input="item.startDateMenu = false;updateFormattedDate(item)"
                            no-title
                            class="my-0"
                          ></v-date-picker>
                        </v-menu>
                    </template>
                    <template v-slot:item.invoiceno="{ item }">
                        <v-text-field
                          ref="refinvorder"
                          :value="item.invoiceNo"
                          @change="value => item.InvoiceNo = value"
                          outlined
                          dense
                          hide-details
                          autocomplete="off"
                          />
                    </template>
                    <template v-slot:item.delete="{ item }">
                      <v-btn color="red" icon @click="remove_data_invoice(invoice_print.invorder.indexOf(item))">
                        <v-icon>
                          fa-trash-alt
                        </v-icon>
                      </v-btn>
                    </template>


                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
              <v-spacer/>
              <v-btn color="green " dark @click="inv_printinvoice()" > {{use_language.print_document}} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_printcoverpage" scrollable persistent max-width="45%" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
          <v-card-title>
            <span > {{use_language.print_cover_sheet}} </span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_printcoverpage=false" > <v-icon>mdi-close</v-icon> </v-btn></v-card-title>
          <v-card-text>
            <v-row row align="center">
              <v-col class="pb-0" cols="12" md="3">
                <h4>{{use_language.choose_document_size}} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="9">
                <v-radio-group v-model="coverpages_print.sizepage" row hide-details>
                  <v-radio :label="use_language.size_a4" value= "a4" ></v-radio>
                  <v-radio :label="use_language.size_10x10" value= "small"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
              <v-spacer/>
              <v-btn color="green " dark @click="printcoverpage()" > {{use_language.print_document}} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_photo" max-width="1200">
        <v-card class="my-0">
          <v-card-text>
            <v-row >
              <v-col cols="12">
                <v-img v-if="dialog_photo_link != null" :src="dialog_photo_link" aspect-ratio="1.5" contain></v-img>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
    import Loading from '@/website/components/Loading'
    import axios from 'axios'
    import Swal from 'sweetalert2'
    import { utils, writeFileXLSX } from 'xlsx';
    import { generalService_dotnet, orderService_dotnet, shopService_dotnet } from '@/website/global'
    import { format_number, format_order_id, format_price, FormatInvoice, SetToDateTime,get_languages,checkAuthorize } from '@/website/global_function'
    import { shippingStatusDict } from '@/website/statusDict'
    import { token_api    } from '@/website/backend/token'
    import { reportService_dotnet } from '../../global'

    // import VueBarcode from 'vue-barcode'
    export default {
        components: {
            Loading,
            // 'barcode': VueBarcode
        },

        data: () => ({
          header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
            channelListSeleced:[],
            channelList:[],
            ShopID:parseInt(localStorage.getItem("shop_id")),
            page_loading: false,
            loading_data: false,
            use_language: {},
            set_language: null,
            authorize:false,
            summary_shipping_status:{
              SumAllShippingStatus:0,
              OpenOrder:0,
              WaitCheck:0,
              WaitPack:0,
              Packing:0,
              Packed:0,
              Ready:0,
              Sent:0,
              Cancel:0
            },
            total_search_data_order_master: 0,
            isFullscreen: false,
            dialog_photo: false,
            dialog_photo_link: null,

            tab_list: null,
            IsSearch: false,
            // archive mode: when true, search hits *_Archive tables via shop-get-order-list-archive
            isArchiveMode: false,
            ExcelFileName:'',
            shippingStatusDict,
            // search
            searchData: null,
            // stub [] — rebuilt with use_language in setMultiLanguage()
            SHitemsStatus: [],

            // stub [] — rebuilt with use_language in setMultiLanguage()
            SHitemsStatusDialog: [],
            SHselectStatus: 0,
            SHshipName: null,
            SHchanelFackbook: null,
            SHchanelLine: null,
            SHchanelEmail: null,
            SHtrackingNo: null,
            SHorderID: null,
            SH_shop_staff: null,
            SH_phone : null,
            SH_ReferenceNumber : null,
            // SH_shop_staff_items: null,
            SH_shop_staff_items: [],
            search_menu_date_range: false,
            search_date_range: [],
            // end search

            // printer
            PrintOrderID: null,
            PrintCODAmount: null,
            PrintShopName: null,
            PrintShopPhone: null,
            PrintShopAddress: null,
            PrintCusName: null,
            PrintCusPhone: null,
            PrintCusAddress: null,


            // search parcel
            summary_parcel_status: null,
            select_search_paid_status_id: null,
            // stub [] — rebuilt with use_language in setMultiLanguage()
            search_paid_status_list: [],
            select_search_parcel_status_id: null,
            // stub [] — rebuilt with use_language in setMultiLanguage()
            search_parcel_status_list: [],
            menu_search_sent_date: false,
            sent_date_range: [],
            menu_search_tranferred_date: false,
            packed_date_range: [],
            // end search parcel
            IsSkipSecondRow:false,
            // Approve
            CanApprove: null,
            dialogMunnyTransfer: false,
            ApproveOrderID: null,
            show_more_detail: false,
            menuCode500: null,
            SeeOtherPeoplesOrder: null,
            menuCode310: null,
            canChangeStatusOrder: null,

            CustomerTransferBankName: null,
            CustomerTransferAccountNumber: null,
            CustomerTransferAccountName: null,
            CustomerTransferAmount: null,
            CustomerTransferPhotoLink: null,
            CustomerTransferCreatedDatetime: null,
            CustomerTransferInformDatetime: null,

            // testDataTable
            headersShow:[],
            // stub [] — rebuilt with use_language in setMultiLanguage()
            headers1: [],

            // headers2 moved to computed (read-only, references use_language)
            IsHeaderShot: false,

            search: '',
            dialog: false,
            showdataTable: [],

            sheetSearching: true,

            detailOrder:[],
            detai_CreatedateTime: '',
            detailOrderProduct:[],
            detailOrderBox:[],
            detai_ID:'',
            detai_statusId : '',
            detai_statusName : '',
            detai_ShopName: '',
            detai_ShopPhone: '',
            detai_ShopAddress:'',
            detai_ShipName: '',
            detai_ShipPhone: '',
            detai_ShippingAddress:'',
            detai_BankName:'',
            detai_AccountNumber:'',
            detai_AccountName:'',
            detai_Remark:'',
            detai_Weight:'',
            detai_Widht:'',
            detai_Height:'',
            detai_Long:'',
            detai_BoxPrice: '',
            detai_CODPercent: '',
            detai_CODCharged: '',
            detai_Discount: '',
            detai_RemotePrice: '',
            detai_DeliveryPrice: '',
            detai_PackPrice: '',
            detail_TrackingNo: '',
            detai_ChannelName: '',
            detai_StaffName: '',
            detai_totalPrice: '',
            detai_DeliveryCost: '',
            detail_Token: '',
            detail_IsCOD: '',
            detai_CustomerType: '',
            get_token: '',
            detai_CODAmount: '',
            shipping_status: [],
            detail_sum_unintPrice: '',
            detail_sum_unintPrice_and_DeliveryCost: '',
            detai_RealTransferDatetime: '',
            detai_ExpressCompanyID: '',

            detai_shiping_staus_update_select: null,

            shipingId: '',
            OrderMasterID: '',
            itemID: '',
            stockID: '',
            stockQuantity: '',
            selected: 0,

            // paginations
            isPage: 0,
            page: 1,
            page_tmp: null,
            limits: 20,
            offsets: 0,
            pageLength: null,

            
            // mobile detail
            showAndHind_key: false,
            index_key: null,

            // export_to_excel
            dialog_excel: false,
            dialog_excel_select: null,
            // dialog_excel_items moved to computed (read-only, references use_language)

            startDate: null,
            menuStartDate: false,
            checkStart: true,

            endDate: null,
            menuEndDate: false,
            checkEnd: true,

            singleSelect: false,
            selected_order:[],

            // time
            time1: "00:00",
            time2: "23:59",
            menutime1: false,
            menutime2: false,

            // print
            inv_dialog_printinvoice: false,
            dialog_printcoverpage: false,
            inv_menu_date_print: false,
            templateorderpage:null,
            // inv_dateprint: new Date().toISOString().substr(0, 10),
            invoice_print: {
              ShopID: parseInt(localStorage.getItem("shop_id")),
              invorder : [],
              titleprint_main: null,
              titleprint_secondary: null,
              date: new Date().toISOString().substr(0, 10)
            },
            coverpages_print:{
              sizepage: "a4",
              // templateorderpage:[],
              ShopID:parseInt(localStorage.getItem("shop_id")),
              OrderID:[]
            },
            // stub [] — rebuilt with use_language in setMultiLanguage()
            inv_titleprintselect: [],
            // select_templateorderpage:[
            //   {text: '---กรุณาเลือก---', value: 0},
            //   {text: '1 ออเดอร์ต่อหน้า', value: 1},
            //   {text: '2 ออเดอร์ต่อหน้า', value: 2},
            //   {text: '4 ออเดอร์ต่อหน้า', value: 3},
            //   {text: '6 ออเดอร์ต่อหน้า', value: 4},
            // ],
            // stub [] — rebuilt with use_language in setMultiLanguage()
            invorderhead:[],
            sizepage: "a4", 

            // Export Excel
            loadingExcel: 0,
            datasetExcel: [],
            datasetExcel_new: [],
            datasetExcelShotFormat_new : [],
            ExcelType : false,
            // new excel
            // excel_row_header moved to computed (read-only, references use_language)

            // excel_order_header moved to computed (read-only, references use_language)
            // excel_order_header_shot moved to computed (read-only, references use_language)
            announceDataTable:[],
            // stub [] — rebuilt with use_language in setMultiLanguage()
            announceHeaders: [],

            excelHeaderChoiceList: [],
            excelHeaderChoose: null,
            loadingBtnExcel: false

        }),

        computed: {
          computed_search_date() {
            return this.formatDate(this.search_date_range)
          },

          computed_search_sent_date() {
            return this.formatDate(this.sent_date_range)
          },

          computed_search_tranferred_date() {
            return this.formatDate(this.packed_date_range)
          },
          computed_date_print() {
            return this.formatDate(this.dateprint)
          },

          // headers2 — moved from data() (read-only, references use_language)
          headers2() {
            if (this.use_language == null) return []
            return [
              { text: this.use_language.number, align: 'center', sortable: false, value: 'num', width:'90px' },
              { text: 'OrderID', align: 'center', sortable: false, value: 'id', width:'100px' },
              { text: this.use_language.sales, align: 'right', value: 'orderTotalAmount', sortable: false, width: '100px'  },
              { text: this.use_language.info_order, align: 'left', value: 'createdDatetime', sortable: false, width:'300px' },
              { text: this.use_language.shipping_details, align: 'left', value: 'receiverName', sortable: false, width: '300px' },
            ]
          },

          // dialog_excel_items — moved from data() (read-only, references use_language)
          dialog_excel_items() {
            if (this.use_language == null) return []
            return [
              {text: this.use_language.all_, value: null},
              {text: this.use_language.open_order, value: 10},
              {text: this.use_language.waiting_check_balance, value: 20},
              {text: this.use_language.wati_pack, value: 30},
              {text: this.use_language.packing, value: 40},
              {text: this.use_language.neatly_packed, value: 50},
              {text: this.use_language.prepare_ship, value: 60},
              {text: this.use_language.shipped, value: 70},
              {text: this.use_language.cancel, value: 90},
            ]
          },

          // excel_row_header — moved from data() (read-only, references use_language)
          excel_row_header() {
            if (this.use_language == null) return []
            return [
              { id: 1, name: this.use_language.order_number, key: "orderID", table: "OrderMaster"},
              { id: 2, name: this.use_language.build_time, key: "createdDatetime", table: "OrderMaster"},
              { id: 3, name: this.use_language.status, key: "shippingStatusName", table: "ShippingStatus"},
              { id: 4, name: this.use_language.transport, key: "expressCompanyName", table: "ExpressCompany"},
              { id: 5, name: "trackingNo", key: "trackingNo", table: "OrderMaster"},
              { id: 6, name: this.use_language.order_confirmation_time, key: "confirmedOrderDate", table: "OrderMaster"},
              { id: 7, name: this.use_language.order_tab_count_packing, key: "packingDate", table: "OrderHistory"},
              { id: 8, name: this.use_language.neatly_packed, key: "packedDate", table: "OrderMaster"},
              { id: 9, name: this.use_language.delivery_time, key: "sendToExpressDatetime", table: "OrderMaster"},
              { id: 10, name: this.use_language.successful_delivery_time, key: "parcelSuccessDateTime", table: "OrderMaster"},

              { id: 11, name: this.use_language.delivery_status, key: "parcelStatusName", table: "ParcelStatus"},
              { id: 12, name: this.use_language.sender_number, key: "senderPhone", table: "ShopAddress"},
              { id: 13, name: this.use_language.sender_name, key: "senderName", table: "ShopAddress"},
              { id: 14, name: this.use_language.sender_address, key: "senderAddress", table: "ShopAddress"},
              { id: 15, name: this.use_language.sender_district, key: "senderSubDistrict", table: "ShopAddress"},
              { id: 16, name: this.use_language.sender_subdistrict, key: "senderDistrict", table: "ShopAddress"},
              { id: 17, name: this.use_language.sender_province, key: "senderProvince", table: "ShopAddress"},
              { id: 18, name: this.use_language.sender_postcode_1, key: "senderPostcode", table: "ShopAddress"},
              { id: 19, name: this.use_language.receiver_phone, key: "receiverPhone", table: "ShippingAddress"},
              { id: 20, name: this.use_language.receiver_name, key: "receiverName", table: "ShippingAddress"},

              { id: 21, name: this.use_language.receiver_address, key: "receiverAddress", table: "ShippingAddress"},
              { id: 22, name: this.use_language.receiver_sub_district, key: "receiverSubDistrict", table: "ShippingAddress"},
              { id: 23, name: this.use_language.receiver_district, key: "receiverDistrict", table: "ShippingAddress"},
              { id: 24, name: this.use_language.receiver_province, key: "receiverProvince", table: "ShippingAddress"},
              { id: 25, name: this.use_language.recipient_postcode, key: "receiverPostcode", table: "ShippingAddress"},
              { id: 26, name: this.use_language.recipient_email, key: "receiverEmail", table: "ShippingAddress"},
              { id: 27, name: this.use_language.recipient_fb, key: "receiverFacebook", table: "ShippingAddress"},
              { id: 28, name: this.use_language.recipient_line, key: "receiverLine", table: "ShippingAddress"},
              { id: 29, name: this.use_language.recipient_address_refer, key: "tempSenderAddress", table: "OrderMaster"},
              { id: 30, name: this.use_language.recipient_address_reference, key: "tempAddress", table: "OrderMaster"},

              { id: 31, name: this.use_language.sales_channel, key: "channelName", table: "ChannelSource"},
              { id: 32, name: this.use_language.shop_name, key: "shopName", table: "OrderMaster"},
              { id: 33, name: this.use_language.bank, key: "shopBank", table: "ShopBankAccount"},
              { id: 34, name: this.use_language.transfer_amount_, key: "shopBankAmount", table: "OrderPayment"},
              { id: 35, name: this.use_language.create_by, key: "createdByStaffShopName", table: "StaffShop"},
              { id: 36, name: this.use_language.salesperson, key: "salemanName", table: "StaffShop"},
              { id: 37, name: this.use_language.total_sku_count, key: "skuCount", table: "OrderMaster"},
              { id: 38, name: this.use_language.total_product_quantity, key: "productCount", table: "OrderMaster"},
              { id: 39, name: this.use_language.parcel_no, key: "packageNo", table: "VOrderItem"}, // query
              { id: 40, name: this.use_language.product, key: "itemName", table: "VOrderItem, OrderItemTemp"}, // query

              { id: 41, name: "SKU", key:"itemSKU", table: "VOrderItem, OrderItemTemp"},
              { id: 42, name: "Barcode", key: "itemBarcode", table: "VOrderItem"},
              { id: 43, name: "Brand", key: "itemBrand", table: "VOrderItem"},
              { id: 44, name: this.use_language.feature1, key: "itemProp1Description", table: "VOrderItem"},
              { id: 45, name: this.use_language.feature2, key: "itemProp2Description", table: "VOrderItem"},
              { id: 46, name: "SerialNo", key: "itemSerialNumber", table: "VOrderItem"},
              { id: 47, name: this.use_language.quantity, key: "itemQuantity", table: "VOrderItem, OrderItemTemp"},
              { id: 48, name: this.use_language.selling_price, key: "itemPrice", table: "VOrderItem, OrderItemTemp"},
              { id: 49, name: this.use_language.product_discount, key: "itemDiscount", table: "VOrderItem, OrderItemTemp"},
              { id: 50, name: this.use_language.category, key: "isCODText", table: "OrderMaster"},

              { id: 51, name: this.use_language.cod_amount, key: "codAmount", table: "OrderMaster"},
              { id: 52, name: this.use_language.total_product_price, key: "totalPrice", table: "OrderMaster"},
              { id: 53, name: this.use_language.seller_discount, key: "totalSellerDiscount", table: "OrderMaster"},
              { id: 54, name: this.use_language.platform_discount, key: "totalPlatformDiscount", table: "OrderMaster"},
              { id: 55, name: this.use_language.order_discount, key: "orderDiscount", table: "OrderMaster"},
              { id: 56, name: this.use_language.delivery_fee, key: "deliveryCost", table: "OrderMaster"},
              { id: 57, name: this.use_language.shipping_discount_from + ' seller', key: "sellerDeliveryDiscount", table: "OrderMaster"},
              { id: 58, name: this.use_language.shipping_discount_from + ' platofrm', key: "platformDeliveryDiscount", table: "OrderMaster"},
              { id: 59, name: "Vat", key: "vat", table: "OrderMaster"},
              { id: 60, name: this.use_language.vat_amount, key: "vatAmount", table: "OrderMaster"},

              { id: 61, name: this.use_language.total_all, key: "orderTotalAmount", table: "OrderMaster"},
              { id: 62, name: this.use_language.freight, key: "deliveryPrice", table: "OrderMaster"},
              { id: 63, name: this.use_language.remote_area_fee, key: "remotePrice", table: "OrderMaster"},
              { id: 64, name: this.use_language.cod_service_fee, key: "codCharged", table: "OrderMaster"},
              { id: 65, name: this.use_language.box_fee, key: "boxPrice", table: "OrderMaster"},
              { id: 66, name: this.use_language.pack_fee, key: "packPrice", table: "OrderMaster"},
              { id: 67, name: this.use_language.discount, key: "discount", table: "OrderMaster"},
              { id: 68, name: this.use_language.bubble_charge, key: "bubblePrice", table: "OrderMaster"},
              { id: 69, name: this.use_language.connection_fee, key: "vrichTransactionFee", table: "OrderMaster"},
              { id: 70, name: this.use_language.reference_number, key: "referenceNumber", table: "OrderMaster"},

              { id: 71, name: this.use_language.invoice_no, key: "invoiceNo", table: "ShopInvoice, OrderMasterInfo"},
              { id: 72, name: this.use_language.tax_invoice_date, key: "invoiceDate", table: "ShopInvoice"},
              { id: 73, name: this.use_language.note, key: "remark", table: "OrderMaster"},
              { id: 74, name: this.use_language.transfer_list, key: "dataPayment", table: "OrderPayment"},
              { id: 75, name: this.use_language.box_name, key: "boxName", table: "OrderMaster"},
              { id: 76, name: "Order Link", key: "orderLink", table: "OrderMaster"},
              { id: 77, name: this.use_language.total_productCost, key: "costPrice", table: "VOrderItem, OrderItemTemp"},
            ]
          },

          // excel_order_header — moved from data() (read-only, references use_language)
          excel_order_header() {
            if (this.use_language == null) return []
            return [
              { id: 1, label: this.use_language.order_number, field: "orderID", width: 15},
              { id: 2, label: this.use_language.status, field: "shippingStatusName", width: 15},
              { id: 3, label: this.use_language.build_time, field: "createdDatetime", width: 20},
              { id: 4, label: this.use_language.transport, field: "expressCompanyName", width: 15},
              { id: 5, label: this.use_language.delivery_time, field: "sendToExpressDatetime", width: 20},
              { id: 6, label: this.use_language.successful_delivery_time, field: "parcelSuccessDateTime", width: 20},
              { id: 7, label: "trackingNo", field: "trackingNo", width: 15},
              { id: 8, label: this.use_language.delivery_status, field: "parcelStatusName", width: 15},
              { id: 9, label: this.use_language.sender_number, field: "senderPhone", width: 15},
              { id: 10, label: this.use_language.sender_name, field: "senderName", width: 20},
              { id: 11, label: this.use_language.sender_address, field: "senderAddress", width: 30},
              { id: 12, label: this.use_language.sender_district, field: "senderSubDistrict", width: 15},
              { id: 13, label: this.use_language.sender_subdistrict, field: "senderDistrict", width: 15},
              { id: 14, label: this.use_language.sender_province, field: "senderProvince", width: 15},
              { id: 15, label: this.use_language.sender_postcode_1, field: "senderPostcode", width: 15},
              { id: 16, label: this.use_language.receiver_phone, field: "receiverPhone", width: 15},
              { id: 17, label: this.use_language.receiver_name, field: "receiverName", width: 20},
              { id: 18, label: this.use_language.receiver_address, field: "receiverAddress", width: 30},
              { id: 19, label: this.use_language.receiver_sub_district, field: "receiverSubDistrict", width: 15},
              { id: 20, label: this.use_language.receiver_district, field: "receiverDistrict", width: 15},
              { id: 21, label: this.use_language.receiver_province, field: "receiverProvince", width: 15},
              { id: 22, label: this.use_language.recipient_postcode, field: "receiverPostcode", width: 15},
              { id: 23, label: this.use_language.recipient_email, field: "receiverEmail", width: 25},
              { id: 24, label: this.use_language.recipient_fb, field: "receiverFacebook", width: 25},
              { id: 25, label: this.use_language.recipient_line, field: "receiverLine", width: 25},
              { id: 26, label: this.use_language.recipient_address_refer, field: "tempSenderAddress", width: 40},
              { id: 27, label: this.use_language.recipient_address_reference, field: "rempAddress", width: 40},
              { id: 28, label: this.use_language.sales_channel, field: "channelName", width: 20},
              { id: 29, label: this.use_language.bank, field: "shopBank", width: 30},
              { id: 30, label: this.use_language.transfer_amount_, field: "shopBankAmount", width: 15},
              { id: 31, label: this.use_language.create_by, field: "createdByStaffShopName", width: 25},
              { id: 32, label: this.use_language.salesperson, field: "salemanName", width: 25},
              { id: 33, label: this.use_language.product, field: "itemName", width: 30},
              { id: 34, label: "SKU", field: "itemSKU", width: 15},
              { id: 35, label: "SerialNo", field: "itemSerialNumber", width: 15},
              { id: 36, label: "Barcode", field: "itemBarcode", width: 15},
              { id: 37, label: this.use_language.feature1, field: "itemProp1Description", width: 15},
              { id: 38, label: this.use_language.feature2, field: "itemProp2Description", width: 15},
              { id: 39, label: "Brand", field: "itemBrand", width: 15},
              { id: 40, label: this.use_language.quantity, field: "itemQuantity", width: 15},
              { id: 41, label: this.use_language.selling_price, field: "itemPrice", width: 15},
              { id: 42, label: this.use_language.product_discount, field: "itemDiscount", width: 15},
              { id: 43, label: this.use_language.category, field: "isCODText", width: 15},
              { id: 44, label: this.use_language.cod_amount, field: "codAmount", width: 15},
              { id: 45, label: this.use_language.total_product_price, field: "totalPrice", width: 15},
              { id: 46, label: this.use_language.seller_discount, field: "totalSellerDiscount", width: 15},
              { id: 47, label: this.use_language.platform_discount, field: "totalPlatformDiscount", width: 15},
              { id: 48, label: this.use_language.order_discount, field: "orderDiscount", width: 15},
              { id: 49, label: this.use_language.delivery_fee, field: "deliveryCost", width: 15},
              { id: 50, label: this.use_language.shipping_discount_from + ' seller', field: "sellerDeliveryDiscount", width: 15},
              { id: 51, label: this.use_language.shipping_discount_from + ' platofrm', field: "platformDeliveryDiscount", width: 15},
              { id: 52, label: "Vat", field: "vat", width: 15},
              { id: 53, label: this.use_language.vat_amount, field: "vatAmount", width: 15},
              { id: 54, label: this.use_language.total_all, field: "orderTotalAmount", width: 15},
              { id: 55, label: this.use_language.freight, field: "deliveryPrice", width: 15},
              { id: 56, label: this.use_language.remote_area_fee, field: "remotePrice", width: 15},
              { id: 57, label: this.use_language.cod_service_fee, field: "codCharged", width: 15},
              { id: 58, label: this.use_language.box_fee, field: "boxPrice", width: 15},
              { id: 59, label: this.use_language.pack_fee, field: "packPrice", width: 15},
              { id: 60, label: this.use_language.discount, field: "discount", width: 15},
              { id: 61, label: this.use_language.bubble_charge, field: "bubblePrice", width: 15},
              { id: 62, label: this.use_language.connection_fee, field: "vrichTransactionFee", width: 15},
              { id: 63, label: this.use_language.reference_number, field: "referenceNumber", width: 15},
              { id: 64, label: this.use_language.note, field: "remark", width: 35},
              { id: 65, label: this.use_language.transfer_list, field: "dataPayment", width: 50},
              { id: 66, label: this.use_language.box_name, field: "boxName", width: 50},
            ]
          },

          // excel_order_header_shot — moved from data() (read-only, references use_language)
          excel_order_header_shot() {
            if (this.use_language == null) return []
            return [
              { label: this.use_language.order_number, field: "orderNo"},
              { label: this.use_language.status, field: "orderStatus"},
              { label: this.use_language.creation_date, field: "createdDatetime"},
              { label: this.use_language.pack_date_col, field: "packedDate"},
              { label: this.use_language.name_product, field: "productName"},
              { label: "SKU", field: "sku"},
              { label: "Barcode", field: "barcode"},
              { label: this.use_language.cf_code, field: "cfCode"},
              { label: this.use_language.quantity, field: "quantity"},
              { label: this.use_language.menu_manageshop, field: "shopName"},
              { label: this.use_language.recipient, field: "receiverName"},
              { label: this.use_language.pack_fee, field: "packPrice"},
              { label: this.use_language.box_fee, field: "boxPrice"},
              { label: this.use_language.freight, field: "deliveryPrice"},
              { label: this.use_language.box_fee + ' + ' + this.use_language.pack_fee, field: "totalPackBoxPrice"},
              { label: this.use_language.bubble_fee, field: "bubblePrice"},
              // { label: "กล่อง", field: "postbox_New"},
              { label: this.use_language.box_size_when_packing, field: "postbox_New"},
              { label: this.use_language.box_size, field: "cubic"},
              { label: this.use_language.sales_channel, field: "channelName"},
              { label: "TrackingNo", field: "trackingNo"},
              { label: "Express", field: "expressCompanyName"},
            ]
          },
        },

        watch: {
          startDate: async function(newVal, oldVal) {
            if (new Date(newVal)>new Date(this.endDate)){
              this.checkStart = false
              this.startDate = oldVal
            }else if(this.checkStart){
              try {
                this.$refs.menuStartDate.save(this.startDate)
              }catch(err){
                console.log(err);
              }
            }else{
              this.checkStart = true
            }
          },
          endDate: async function(newVal, oldVal) {
            if (new Date(newVal)<new Date(this.startDate) || new Date(newVal)>new Date()){
              this.checkEnd = false
              this.endDate = oldVal
            }else if(this.checkEnd){
              try {
                this.$refs.menuEndDate.save(this.endDate)
              }catch(err){
                console.log(err);
              }
            }else{
              this.checkEnd = true
            }
          },
        },

        async created() {

           //เก็บภาษามาไว้ใน use_language
            this.use_language = await this.get_languages(localStorage.getItem("set_language"));
            this.setMultiLanguage()

               //เช็คสิทธิ์แก้ไขหรือดูได้อย่างเดียว
            this.get_authorize_staffshop();



            localStorage.removeItem("OrderToken")
         
            this.staff_id = localStorage.getItem("staff_id")
            // แบบเก่ารอการแก้ไข
            this.CanApprove = JSON.parse(localStorage.getItem("permission"))['ApproveOrder']
            this.canChangeStatusOrder = JSON.parse(localStorage.getItem('permission'))['ChangeStatusOrder']
            this.submit_edit_order = JSON.parse(localStorage.getItem('submit_edit_order'))
            this.SeeOtherPeoplesOrder = JSON.parse(localStorage.getItem('permission'))['SeeOtherPeoplesOrder']

            // แบบใหม่
            // this.canSeeReport = JSON.parse(localStorage.getItem('permission'))['PageReport']
            // this.menuCode500 = localStorage.getItem("500") //รายงาน
            // this.AddOrder_permisstion = JSON.parse(localStorage.getItem('permission'))['AddOrder']
            // this.menuCode310 = localStorage.getItem("310") //สร้างออเดอร์ใหม่

            this.headersShow = this.headers1

            localStorage.removeItem('submit_edit_order')

            this.getShopChannel();
            if( this.submit_edit_order != null ){
              await this.select_shipping_status_button(localStorage.getItem("selected"))
              await this.load_data_tmp(localStorage.getItem("selected"), null, null)
            } else {
              await this.load_data_tmp(0, null, null)
            }
            await this.getAnnounceShow()

         
        },

        methods: {
        setMultiLanguage() {
          this.SHitemsStatus = [
              {text: this.use_language.all_, value: 0},
              {text: this.use_language.open_order, value: 10},
              {text: this.use_language.waiting_check_balance, value: 20},
              {text: this.use_language.wati_pack, value: 30},
              {text: this.use_language.packing, value: 40},
              {text: this.use_language.neatly_packed, value: 50},
              {text: this.use_language.prepare_ship, value: 60},
              {text: this.use_language.shipped, value: 70},
              {text: this.use_language.cancel, value: 90},
            ]

            this.SHitemsStatusDialog = [
              {text: this.use_language.all_, value: 10},
              {text: this.use_language.waiting_check_balance, value: 20},
              {text: this.use_language.wati_pack, value: 30},
              {text: this.use_language.packing, value: 40},
              {text: this.use_language.neatly_packed, value: 50},
              {text: this.use_language.prepare_ship, value: 60},
              {text: this.use_language.shipped, value: 70},
              {text: this.use_language.cancel, value: 90},
            ]

            this.search_paid_status_list = [
              {text: this.use_language.all_kinds, value: 0}, 
              {text: this.use_language.transferred, value: 1}, 
              {text: this.use_language.not_transferred, value: 2}
            ]

            this.search_parcel_status_list = [
              {text: this.use_language.all_kinds, value:-1},
              {text: this.use_language.during_delivery, value: 1},
              {text: this.use_language.order_tab_count_returning, value: 2},
              {text: this.use_language.bounce + ', ' +	this.use_language.order_tab_count_to_return_stock, value: 3},
              {text: this.use_language.bounce + ', ' +	this.use_language.order_tab_count_stock_returned, value: 4},
              {text: this.use_language.successful_delivery, value: 5}
            ]

            this.inv_titleprintselect = [
              {text: this.use_language.please_select_, value: 0},
              {text: this.use_language.receipt, value: 1},
              {text: this.use_language.tax_invoice, value: 2},
              {text: this.use_language.delivery_note, value: 3},
              {text: this.use_language.invoice, value: 4},
              {text: this.use_language.invoice_, value: 5},
              {text: this.use_language.quotation, value: 6},
            ]

            this.invorderhead = [
              { align: 'center', text: 'OrderID', value: 'orderid', sortable: false  },
              { align: 'center', text: this.use_language.date, value: 'dateString', sortable: false },
              { align: 'center', text: this.use_language.document_number, value: 'invoiceno', sortable: false },
              { align: 'center', text: '', value: 'delete', sortable: false },

            ]

            this.announceHeaders = [
              { text: this.use_language.announce_date, align: 'center', sortable: false, value: 'startDate', width: '200px'},
              { text: this.use_language.subject, align: 'center', sortable: false, value: 'subject', width: '200px'},
              { text: this.use_language.details, align: 'left', sortable: false, value: 'description', width: '500px'},
              { text: this.use_language.tb_image, align: 'center', sortable: false, value: 'photoLink', width: '20px'},
              { text: this.use_language.announce_from, align: 'center', sortable: false, value: 'announceFrom', width: '100px'},
            ]

            this.headers1 = [
              { text: this.use_language.tb2_no, align: 'center', sortable: false, value: 'num' },
              { text: this.use_language.order_id, align: 'center', sortable: false, value: 'id', width:'120px' },
              { text: this.use_language.build_time, align: 'left', value: 'createdDatetime', sortable: false, width:'170px' },
              { text: this.use_language.recipient_name, align: 'left', value: 'receiverName', sortable: false, width: '250px' },
              { text: this.use_language.channel, align: 'center', value: 'channelLogo', sortable: false },
              { text: this.use_language.transport, align: 'center', value: 'expressCompanyLogo', sortable: false },
              { text: this.use_language.sales, align: 'right', value: 'orderTotalAmount', sortable: false, width: '120px'  },
              { text: this.use_language.transmission_type, align: 'center', value: 'isCod', sortable: false },
              { text: this.use_language.total_cod, align: 'right', value: 'codamount', sortable: false , width: '120px' },
              { text: this.use_language.order_status_, align: 'center', value: 'shippingStatusName', sortable: false, width: '130px' },
              { text: this.use_language.parcel_status, align: 'center', value: 'parcelStatusName', sortable: false, width: '110px' },
              { text: this.use_language.reference_number, align: 'left', value: 'referenceNumber', sortable: false, width:'130px' },
              { text: this.use_language.tracking_no, align: 'left', value: 'trackingNo', sortable: false, width:'130px' },
              { text: this.use_language.create_by, align: 'left', value: 'createdByStaffName', sortable: false, width:'130px' },
              { text: this.use_language.salesperson, align: 'left', value: 'salemanName', sortable: false, width:'130px' },
            ]
        },
        goToHeaderSetting() {
          window.open('shop-setting?to='+'excel');
        },
        async getExcelHeaderList() {
          this.loadingBtnExcel = true
          let response = await axios.post(
            shopService_dotnet + 'ShopSetting/get-header-excel-list',
            { 'shopID': parseInt(localStorage.getItem("shop_id")) }, 
            {headers: this.header_token} 
          )

          var findDefault = response.data.filter(i => i.isDefault == true)[0]
          this.excelHeaderChoiceList = response.data.filter(i => i.isDefault == false)
          this.excelHeaderChoiceList.unshift(findDefault)

          this.excelHeaderChoiceList = this.excelHeaderChoiceList.map((item) => {
            item.value = item.id, item.text = item.templateName
            return {...item}
          })

          this.excelHeaderChoose = this.excelHeaderChoiceList[0]
          this.dialog_excel = true
          this.loadingBtnExcel = false
        },
        get_languages,
        checkAuthorize,
        detail_page (id) {
          window.open('order-detail?id='+id, '_blank');
        },
        archive_detail_page (id) {
          // Archived orders open in the dedicated read-only detail page.
          window.open('order-detail-archive?id='+id, '_blank');
        },
        async onOrderTypeChange () {
          // เปลี่ยนประเภทออเดอร์จาก radio (isArchiveMode ถูก v-model set ก่อน @change แล้ว) — เคลียร์ผลเดิม + paging
          this.page = 1
          this.offsets = 0
          this.pageLength = 0
          this.total_search_data_order_master = 0
          this.IsSearch = false
          this.showdataTable = []
          this.selected_order = []
          this.selected = 0
          if (this.isArchiveMode) {
            // โหมดจัดเก็บ: ไม่ default ช่วงวันที่ และไม่ auto-search — ให้ผู้ใช้เลือก filter เองแล้วกดค้นหา
            // ใช้ tab_list = 0 (item แรก) — ไม่ใช้ 9 เพราะลบ tab คลังประวัติออกแล้ว ไม่งั้น v-tabs-items จะ slide ซ้ายดูแปลก
            this.tab_list = 0
            this.IsSearch = false
            this.showdataTable = []
          } else {
            // โหมดปัจจุบัน: กลับไปแท็บ "ทั้งหมด" + โหลดออเดอร์ปัจจุบัน
            this.tab_list = 0
            await this.select_shipping_status_button(0)
          }
          this.selected_order = []
        },

        format_number,
        format_order_id,
        format_price,
        FormatInvoice,
        SetToDateTime,
        allowedDates: val => val <= SetToDateTime('date',new Date(),0),
        image_click(photo_link) {
            this.dialog_photo_link = photo_link
            this.dialog_photo = true
        },

        edit_order () {
          localStorage.setItem('OrderToken', this.get_token)
          this.$router.push('/edit-order')
        },

        edit_date_format_for_dotnet ( val ){
          const _date = new Date(val)
          var informDatetime_tmp = new Date( _date.getTime() + 7 * (60 * 60 * 1000) ).toISOString()
          return informDatetime_tmp
        }, 
        formatDate (date) {
          if (date.length == 0) return null

          if (date.length == 1) {
            const [year, month, day] = date[0].split('-')
            return `${day}-${month}-${year}`
          } else {
            const [year_from, month_from, day_from] = date[0].split('-')
            const [year_to, month_to, day_to] = date[1].split('-')
            if (date[0] < date[1]) {
              return `${day_from}-${month_from}-${year_from} ~ ${day_to}-${month_to}-${year_to}`
            } else {
              return `${day_to}-${month_to}-${year_to} ~ ${day_from}-${month_from}-${year_from}`
            }
          }
        },

        gen_num_data_table (index) {
          if(index != null && this.loading_data == false) {
            var start = null
            if(this.selected == 30){
              start = 1 + this.offsets
              return format_number(start + index)
            }else {
              start = this.total_search_data_order_master - this.offsets
              return format_number(start - index )
            }
          } else {
            return ""
          }
        },


        set_format_date_time (val) {
          if(val != null){
            var date_tmp = val.substring(0, 10)
            const date_split = date_tmp.split('-');
            var time_tmp = val.substring(11, 19)
            var set_dattime = date_split[2]+'-'+date_split[1]+'-'+date_split[0] +' '+ time_tmp
            return set_dattime
          } else {
            return ""
          }
        },
        updateFormattedDate(item){
          if (!item.date) return null
          const [year, month, day] = item.date.split('-')
          item.dateString = `${day}-${month}-${year}`
        },

        async getAnnounceShow() {
          let response = await axios.post(
            generalService_dotnet + 'Announce/get-announce-shop',
            {
              "shopID": this.ShopID,
              "staffID": parseInt(localStorage.getItem('staff_id'))
            },
            { headers: this.header_token}
          )
          if (response.status == 200) {
            this.announceDataTable = response.data.forTable
          }
        },

        async load_data_tmp (ShippingStatusID, search_data, offset) {

          this.loading_data=true; 
          if(search_data == null) 
          {
            search_data = {
              "ShippingStatusID": ShippingStatusID,
              "ReceiverName": null,
              "TrackingNo": null,
              "OrderID":null,
              "StaffShopName":null,
              "ReceiverPhone":null,
              "ReferenceNumber": null,
              "CreatedFrom":null,
              "CreatedTo": null, 
              "PaidStatusID": null,
              "ParcelStatusID": null,
              "SendDateFrom": null,
              "SendDateTo": null,
              "PackedDateFrom": null,
              "PackedDateTo": null
            }

             
          }

          if(offset == null){
            offset = 0
          }
         

          var orderby = 2
          if (ShippingStatusID == 30&&ShippingStatusID < 70) {
            orderby = 1
          } else {
            orderby = 2
          }
          search_data.orderby=orderby;

          // check perrmisstion เห็น ออเดอร์คนอื่นหรือไม่
          var staff_sumery_id = null
          // if(this.SeeOtherPeoplesOrder == false){
          //   SH_shop_staff = localStorage.getItem('staff_id')
          //   staff_sumery_id =  localStorage.getItem('staff_id')
          // }
        
          
          // Archive mode reroutes the list call to the *_Archive-backed endpoint.
          const orderListUrl = this.isArchiveMode
            ? orderService_dotnet + 'Order/shop-get-order-list-archive'
            : orderService_dotnet + 'Order/shop-get-order-list';
          await axios.all([
            axios.post(orderListUrl,{
                "orderIDText": search_data.OrderID ,
                "shopID": this.ShopID,
                "referenceNumberText": search_data.ReferenceNumber, 
                "dateFrom": search_data.CreatedFrom,
                "dateTo": search_data.CreatedTo,
                "sendToExpressDatetime_From": search_data.SendDateFrom,
                "sendToExpressDatetime_To": search_data.SendDateTo,
                "packDateFrom": search_data.PackedDateFrom,
                "packDateTo": search_data.PackedDateTo,
                "receiverPhone":  search_data.ReceiverPhone,
                "receiverName":  search_data.ReceiverName,
                "trackingNo": search_data.TrackingNo,
                "shippingStatusID": search_data.ShippingStatusID,
                "paidStatusID":  search_data.PaidStatusID,
                "parcelStatusID": search_data.ParcelStatusID,
                "createdByStaffID": search_data.StaffShopName,
                "isNeedStatusCount": true,
                "channelIDList": this.channelListSeleced.map(function(item){return item.uniqueID;}),
                "skip": offset,
                "take": 20,
                "orderby": search_data.orderby,
                "searchByStaffID": this.staff_id
            },{ headers: this.header_token}),
            // axios.post(orderService_dotnet + 'Order/get-order-summary',{
            //     "orderID": null,
            //     "branchID": null,
            //     "shopID": this.shop_id,
            //     "warehouseID": null,
            //     "dateFrom": null,
            //     "dateTo": null,
            //     "receiverName": null,
            //     "referenceNumber": SH_ReferenceNumber,
            //     "trackingNo": tracking_no,
            //     "shippingStatusID": null,
            //     "parcelStatusID": parcel_status_id,
            //     "isNeedStatusCount": false,
            //     "createdByStaffID": SH_shop_staff,
            //     "seeOtherPeoplesOrder": true,//this.SeeOtherPeoplesOrder,
            //     "skip": 0,
            //     "take": offset,
            //     "orderby": orderby
            // },{ headers: this.header_token}),
            axios.post(shopService_dotnet + 'Shop/get-shop-staff',{'shopID': this.ShopID},{ headers: this.header_token}),
          ]).then(axios.spread((res_order_master,   res_shop_staff) => {
            this.index_key = null
            // กรณี backend คืน error (เช่น ค้นหา archive โดยไม่ระบุวันที่/ตัวระบุ) — แจ้งเตือนแทนตารางว่างเงียบ
            if (res_order_master.data && res_order_master.data.status === 'error') {
              this.showdataTable = []
              this.total_search_data_order_master = 0
              this.pageLength = 0
              this.loading_data = false
              Swal.fire({ icon: 'warning', text: res_order_master.data.error_description || this.use_language.cannot_search })
              return
            }
            this.showdataTable = res_order_master.data.orderList

            var status_count = {
              "Cancel": 0,
              "OpenOrder": 0,
              "Packed": 0,
              "Packing": 0,
              "Ready": 0,
              "Sent": 0,
              "SumAllShippingStatus": 0,
              "WaitCheck": 0,
              "WaitPack": 0
            }
            var sum_total = 0

            for (var i = 0; i < res_order_master.data.statusCount.length; i++) {
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 10){
                status_count.OpenOrder = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 20){
                status_count.WaitCheck = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 30){
                status_count.WaitPack = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 40){
                status_count.Packing = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 50){
                status_count.Packed = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 60){
                status_count.Ready = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 70){
                status_count.Sent = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
              // if(res_order_master.data.statusCount[i]['shippingStatusID'] == 80){
              //   status_count.OpenOrder = res_order_master.data.statusCount[i]['count']
              // }
              if(res_order_master.data.statusCount[i]['shippingStatusID'] == 90){
                status_count.Cancel = res_order_master.data.statusCount[i]['count']
                sum_total = sum_total + res_order_master.data.statusCount[i]['count']
              }
            }
            status_count.SumAllShippingStatus = sum_total
            this.summary_shipping_status = status_count
            this.total_search_data_order_master = res_order_master.data.searchResultCount
            var percent = 0
            // var total = res_order_summary.data.parcelReturned + res_order_summary.data.parcelDelivered
            // if (total > 0 && res_order_summary.data.parcelDelivered > 0) {
            //   percent = ((res_order_summary.data.parcelDelivered*100)/total).toFixed(2)
            // }
            // var codAmount_tmp = res_order_summary.data.codAmount
            // var codTransferred_tmp = res_order_summary.data.codTransferred
            // var codWaitingToTransfer_tmp = res_order_summary.data.codWaitingToTransfer
            // if(codAmount_tmp === undefined){
            //   codAmount_tmp = 0
            // }

            // if(codTransferred_tmp === undefined){
            //   codTransferred_tmp = 0
            // }

            // if(codWaitingToTransfer_tmp === undefined){
            //   codWaitingToTransfer_tmp = 0
            // }
            // var summary_tmp ={
            //   "COD": res_order_summary.data.cod,
            //   "codAmount": this.format_price(codAmount_tmp),
            //   "NotCOD": res_order_summary.data.notCOD,
            //   "ParcelStatusID1": res_order_summary.data.parcelDeliverying,
            //   "ParcelStatusID2": res_order_summary.data.parcelReturned,
            //   "ParcelStatusID3": res_order_summary.data.parcelDelivered,
            //   "Percent": percent,
            //   "Transferred": this.format_price(codTransferred_tmp),
            //   "WaitingToTransfer": this.format_price(codWaitingToTransfer_tmp)
            // }
            // this.summary_parcel_status = summary_tmp
            this.SH_shop_staff_items = []

            for (var i2 = 0; i2 < res_shop_staff.data.length; i2++) {
              this.SH_shop_staff_items.push({'text': res_shop_staff['data'][i2]['name'], 'value': res_shop_staff['data'][i2]['id']})
            }
            this.getpagelength(this.total_search_data_order_master)
            this.loading_data=false;
          }));
        },

        async select_shipping_status_button(shipping_status_id) {
            this.page = 1
            this.loadingExcel=0;
            this.SearchingClearData()
            this.selected = shipping_status_id
            localStorage.setItem("selected", shipping_status_id)
    
            this.sheetSearching = true
            await this.load_data_tmp(shipping_status_id, null, null)
            
        },
        PrepareSearchKeyword(){
          if (this.SH_shop_staff == '') { this.SH_shop_staff = null }
               if(this.SHchanelFackbook == ''){ this.SHchanelFackbook = null } else { this.SHchanelFackbook }
          if(this.SHchanelLine == ''){ this.SHchanelLine = null } else { this.SHchanelLine }
          if(this.SHchanelEmail == ''){ this.SHchanelEmail = null } else { this.SHchanelEmail }


          if(this.SHshipName == ''){ this.SHshipName = null } else { this.SHshipName }
          if(this.SHtrackingNo == ''){ this.SHtrackingNo = null } else { this.SHtrackingNo }
          if(this.SHorderID == ''){ this.SHorderID = null } else { this.SHorderID }
          if(this.SH_phone == ''){ this.SH_phone = null } else { this.SH_phone }
          if(this.SH_ReferenceNumber == ''){ this.SH_ReferenceNumber = null } else { this.SH_ReferenceNumber }

          this.searchData = {
            "ShippingStatusID": this.SHselectStatus,
            "ReceiverName": this.SHshipName,
            "TrackingNo": this.SHtrackingNo,
            "OrderID": this.SHorderID,
            "StaffShopName": this.SH_shop_staff != null?this.SH_shop_staff['value']:null,
            "ReceiverPhone": this.SH_phone != null?this.SH_phone:null,
            "ReferenceNumber": this.SH_ReferenceNumber != null?this.SH_ReferenceNumber:null,
            "PaidStatusID": this.select_search_paid_status_id,
            "ParcelStatusID": this.select_search_parcel_status_id,
          }

          var created_date_range = this.search_date_range
          var dateFrom = null
          var dateTo = null
          if(created_date_range.length != 0){
            if(created_date_range.length == 1) {
              dateFrom = created_date_range[0] + " 00:00:00"
              dateTo   = created_date_range[0] + " 23:59:59"
            } else {
              dateFrom = created_date_range[0] + " 00:00:00"
              dateTo   = created_date_range[1] + " 23:59:59"
            }
              
          }
          var sent_date_range =  this.sent_date_range
          var sent_dateFrom = null
          var sent_dateTo = null
          if(sent_date_range.length != 0){
            if(sent_date_range.length == 1) {
              sent_dateFrom = sent_date_range[0] + " 00:00:00"
              sent_dateTo   = sent_date_range[0] + " 23:59:59"
            } else {
              sent_dateFrom = sent_date_range[0] + " 00:00:00"
              sent_dateTo   = sent_date_range[1] + " 23:59:59"
            }
              
          }
          var packed_date_range = this.packed_date_range
          var packed_dateFrom = null
          var packed_dateTo = null
          if(packed_date_range.length != 0){
            if(packed_date_range.length == 1) {
              packed_dateFrom = packed_date_range[0] + " 00:00:00"
              packed_dateTo   = packed_date_range[0] + " 23:59:59"
            } else {
              packed_dateFrom = packed_date_range[0] + " 00:00:00"
              packed_dateTo   = packed_date_range[1] + " 23:59:59"
            }
              
          }
          this.searchData.PackedDateFrom= packed_dateFrom;
          this.searchData.PackedDateTo= packed_dateTo;
          this.searchData.CreatedFrom= dateFrom;
          this.searchData.CreatedTo= dateTo;
          this.searchData.SendDateFrom= sent_dateFrom; 
          this.searchData.SendDateTo= sent_dateTo;
        },
        async Searching() {
          this.loading_data = true
          this.loadingExcel=false;
          this.page = 1
          // หมายเหตุ: โหมดจัดเก็บไม่ default ช่วงวันที่แล้ว — ค้นหาตาม filter ที่ผู้ใช้กรอกเอง
          this.PrepareSearchKeyword();

          this.IsSearch = true
          this.selected = 0
          // ใช้ tab_list = 0 เสมอ (ลบ tab คลังประวัติออกแล้ว) — กัน v-tabs-items slide ซ้ายดูแปลกในโหมด archive
          this.tab_list = 0
          await this.load_data_tmp(this.searchData["ShippingStatusID"], this.searchData, null)
          this.selected_order = []

        },

        SearchingClearData () {
          // this.SHselectStatus = []
          this.searchData = null
          this.SHselectStatus = 0
          this.search_date_range = []
          this.SHshipName = null
          this.SHchanelFackbook = null
          this.SHchanelLine = null
          this.SHchanelEmail = null
          this.SHtrackingNo = null
          this.SHorderID = null
          this.SH_shop_staff = null
          this.SH_phone = null
          this.SH_ReferenceNumber = null
          this.select_search_paid_status_id = null
          this.select_search_parcel_status_id = null
          this.sent_date_range = []
          this.packed_date_range = []
        },

        copyToken () {
          // this.detail_Token
          let TokenCodeToCopy = document.querySelector('#testing-code')
          TokenCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
          TokenCodeToCopy.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? this.use_language.success : this.use_language.fail;
            this.$swal({
              toast: true,
              timer: 1500,
              showConfirmButton: false,
              position: 'top',
              type: 'success',
              title: this.use_language.copied + msg
            })
          } catch (err) {
            this.$swal({
              type: 'warning',
              title: this.use_language.error,
              text: this.use_language.copy_failed,
            })
          }

          /* unselect the range */
          TokenCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },

        getpagelength (total_order_master) {
          var total = 0
          if(total_order_master != 0){
            total = total_order_master
          } else {
            total = 1
          }

          total = parseInt(total)
          this.pageLength = Math.ceil(total/this.limits)
          this.isPage = 0
          this.page_tmp = this.page
        },

        async changePage() {
          this.loading_data = true
          this.loadingExcel=0;
          this.offsets = (this.page*this.limits)-this.limits

          if (this.page > 1 && this.page < this.pageLength ) {
            if(this.page_tmp != this.page){
              if (this.searchData != null) {
                await this.load_data_tmp(this.searchData["ShippingStatusID"], this.searchData, this.offsets)
              } else {
                await this.load_data_tmp(this.selected, null, this.offsets)
              }
              this.page_tmp = this.page
            }
          } else if(this.page == 1,this.pageLength ) {
            if(this.page_tmp != this.page){
              if (this.searchData != null) {
                await this.load_data_tmp(this.searchData["ShippingStatusID"], this.searchData, this.offsets)
              } else {
                await this.load_data_tmp(this.selected, null, this.offsets)
              }
              this.page_tmp = this.page
            }
          }
          this.loading_data = false
        },
        async GetData(isNeedResultCount,isNeedOnlyOrderMasterID,skip,take){
          try {
            // Archive mode posts to the archive endpoint; live mode keeps the original endpoint untouched.
            const orderListUrl = this.isArchiveMode
              ? orderService_dotnet + 'Order/shop-get-order-list-archive'
              : orderService_dotnet + 'Order/shop-get-order-list';
            let response = await axios.post(orderListUrl,{
                  "orderIDText": this.searchData.OrderID , 
                  "shopID": this.ShopID,
                  "referenceNumberText": this.searchData.ReferenceNumber, 
                  "dateFrom": this.searchData.CreatedFrom,
                  "dateTo": this.searchData.CreatedTo,
                  "sendToExpressDatetime_From": this.searchData.SendDateFrom,
                  "sendToExpressDatetime_To": this.searchData.SendDateTo,
                  "packDateFrom": this.searchData.PackedDateFrom,
                  "packDateTo": this.searchData.PackedDateTo,
                  "receiverPhone":  this.searchData.ReceiverPhone,
                  "receiverName":  this.searchData.ReceiverName,
                  "trackingNo": this.searchData.TrackingNo,
                  "shippingStatusID": this.searchData.ShippingStatusID,
                  "paidStatusID":  this.searchData.PaidStatusID,
                  "parcelStatusID": this.searchData.ParcelStatusID,
                  "createdByStaffID": this.searchData.StaffShopName,
                  "isNeedStatusCount": true,
                  "channelIDList": this.channelListSeleced.map(function(item){return item.uniqueID;}),
                  "isNeedResultCount":isNeedResultCount,
                  "isNeedOnlyOrderMasterID":isNeedOnlyOrderMasterID,
                  "skip": skip,
                  "take": take,
                  "orderby":  this.searchData.orderby,
                  "searchByStaffID": this.staff_id
              },{ headers: this.header_token});
              return response;
          } catch (error) {
            return {status:500};
          }
          
        },
        async get_order_export_excel() {
          this.loadingExcel = 1
          this.loading_data=true;
          let OrderMasterIDList=[]
          let limits= 1000;
          let offsets=0;
          let CurrentRound=1;
          let TotalRound=100;
         
          const d = new Date();
          let dateExported =d.getFullYear().toString()+(d.getMonth()+1).toString() +d.getDate().toString() + d.getHours().toString()+d.getMinutes().toString()+d.getSeconds().toString();
          this.ExcelFileName = this.use_language.order_data_report_file+dateExported;
          var alertMessage=this.use_language.warnin_try_again_contact_it;
          var isError=false;
            
          this.PrepareSearchKeyword();
          while (CurrentRound<=TotalRound) 
          {
            let isThisRoundPass=false;
            while (!isThisRoundPass)
            {
              let response = await this.GetData(true,true,offsets,limits);
              
              if(response.status==200)
              {
                if(response.data.status=="error")
                {
                  if(!response.data.isDatabaseNetwork){ 
                    // show error and stop
                  
                      
                    this.$swal({
                      type: 'error',
                      title: this.use_language.error,
                      text: response.data.error_description,
                    })
                    return; 
                  }
                }
                else
                {
                  OrderMasterIDList.push(...response.data.orderMasterIDList)
                  if(CurrentRound==1){
                    TotalRound = Math.ceil(response.data.searchResultCount/limits);
                  }
                  
                  let percent=  parseInt((CurrentRound / ((TotalRound*2)+1))*100);
                  if(percent<1)
                    percent=1;
                  this.loadingExcel = percent;
                  CurrentRound++;
                  offsets = offsets + limits;
                  isThisRoundPass=true;
                }
              } 
              else 
              {
                this.$swal({
                  type: 'error',
                  title: this.use_language.error,
                  text: this.use_language.error_occurred_contact_Admin,
                })
                return;
              }
            }
          }

          offsets = 0
          this.datasetExcel_new = []
          let sumRound=CurrentRound;
          CurrentRound=1; 

          var headerIdList = this.excelHeaderChoose.headersID.split(",").map(i => parseInt(i))
          var forHeadRowSort = headerIdList.map(id => this.excel_row_header.find(item => item.id === id)).filter(Boolean)
          var mapTable = forHeadRowSort.map(i => i.table)
          const tableList = [...new Set(mapTable.flatMap(i => i.split(",")).map(i => i.trim()))];
          
          while(CurrentRound<=TotalRound) {

            var isThisRoundPass=false;
            while (!isThisRoundPass)
            {
              let response
              try {
                response = await axios.post(
                  orderService_dotnet+'Order/get-order-export-to-excel-v2',
                  {
                    "orderMasterIDList": OrderMasterIDList.slice((CurrentRound-1)*limits,(CurrentRound-1)*limits + limits),
                    "isSkipSecondRow": !this.IsSkipSecondRow,
                    "queryTableList": tableList
                  },
                  { headers: this.header_token}
                )
              } catch (err) {
                this.loadingExcel = 0
                this.loading_data = false
                this.$swal({
                  type: 'error',
                  title: this.use_language.error,
                  text: this.use_language.cannot_proceed_try_again,
                })
                return
              }
              if(response.status==200)
              {
                if(response.data.status=="error")
                {
                  if(!response.data.isDatabaseNetwork){ 
                    // show error and stop
                    this.$swal({
                      type: 'error',
                      title: this.use_language.error,
                      text: response.data.error_description,
                    })
                    return; 
                  }
                }
                else
                {
                  for (var index in response.data.items){
                    this.datasetExcel_new.push(response.data.items[index])
                  }
                  let percent=  parseInt((sumRound / ((TotalRound*2+1)))*100);
                  sumRound++;
                  CurrentRound++;
                  if(percent<1)
                    percent=1;
                  this.loadingExcel = percent
                  offsets = offsets + limits;
                  isThisRoundPass=true;
                }
              } 
              else 
              {
                this.$swal({
                  type: 'error',
                  title: this.use_language.error,
                  text: this.use_language.error_occurred_contact_Admin,
                })
                return;
              }
            }
            
          } 
          
          this.datasetExcel_new.map((item) => {
            item.shopName = item.platformShopName || JSON.parse(localStorage.getItem("shop"))['name']
            return {...item}
          })

          var forHeadRow = null
          var forHeadKey = null

          if (this.excelHeaderChoose.id == 0) {
            forHeadRow = [this.excel_row_header.map(i => i.name)]
            forHeadKey = this.excel_row_header.map(i => i.key)
          } else {
            forHeadRowSort = headerIdList.map(id => this.excel_row_header.find(item => item.id === id)).filter(Boolean)
            forHeadRow = [forHeadRowSort.map(i => i.name)]
            forHeadKey = forHeadRowSort.map(i => i.key)
          }
          
          var excelDataRaw = this.datasetExcel_new.map(row =>
            forHeadKey.reduce((obj, key) => {
              obj[key] = row[key] ?? "";
              return obj;
            }, {})
          );

          const excelData = excelDataRaw.filter(obj =>
            Object.values(obj).some(v =>
              v !== null &&
              v !== undefined &&
              String(v).trim() !== ""
            )
          );

          const maxRowsPerFile = 50000;
          const partCount = Math.max(1, Math.ceil(excelData.length / maxRowsPerFile));
          for (let part = 0; part < partCount; part++) {
            const rows = excelData.slice(part * maxRowsPerFile, (part + 1) * maxRowsPerFile);
            const ws = utils.json_to_sheet([]);
            utils.sheet_add_aoa(ws, forHeadRow);
            utils.sheet_add_json(ws, rows, { origin: 'A2', skipHeader: true });
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "sheet1");
        
            const partSuffix = partCount > 1 ? "_" + (part + 1) : "";
            writeFileXLSX(wb, this.use_language.order_data_report_file+dateExported+partSuffix+".xlsx");
            if (part < partCount - 1) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }
          }
          this.loadingExcel=100;
          this.loading_data=false;
        },

        async get_data_order_excel_new (limits, offsets) {
          let response = await axios.post(orderService_dotnet+'Order/get-order-export-to-excel',{
            "shopID":  this.ShopID,
            "shippingStatusID": this.dialog_excel_select,
            "dateFrom": this.startDate +  ' ' + this.time1,
            "dateTo": this.endDate + ' ' + this.time2,
            "limits" : limits ,
            "offsets" : offsets,
            "isSkipSecondRow":!this.IsSkipSecondRow
          } , { headers: this.header_token})
          if(response.data.length > 0){
            return response.data
          } else {
            return []
          }

        },
        async get_shop (limits, offsets) {
          let response = await axios.post(shopService_dotnet+'Shop/get-shop',{
            "shopID":  this.ShopID
          
          } , { headers: this.header_token})
          if(response.data.length > 0){
            return response.data
          } else {
            return []
          }

        },


        async get_count_order_excel_new_shot_format () {
          this.loadingExcel = 1
          let res1 = await axios.post(orderService_dotnet+'Order/get-count-order-to-excel',{
            "shopID":  this.ShopID,
            "shippingStatusID": this.dialog_excel_select,
            "dateFrom": this.startDate +  ' ' + this.time1,
            "dateTo": this.endDate + ' ' + this.time2
          } , { headers: this.header_token})


          try {
            this.datasetExcelShotFormat_new = []

            var percent = 1;
            var limits = 3000
            var total = res1.data
            var offsets = 0
            var loadingExcel = 0

            var Round =parseInt( total / limits);
            if(limits*Round < total){
              Round=Round+1;
            }

            for (var i =1; i <=Round; i++) {
              percent =parseInt(i / Round * 100)

              var Ndata = await this.get_data_order_excel_new_shot_format(limits,offsets)
              for (var jj in Ndata){
                this.datasetExcelShotFormat_new.push(Ndata[jj])
              }
              this.loadingExcel = percent
              offsets = offsets + limits;
            }
            await this.get_shop( )
            await document.getElementById("GetExcelShot").click();
            this.datasetExcelShotFormat_new = []
            this.loadingExcel = 0


          } catch (e) {
            this.$swal({
              type: 'warning',
              title: this.use_language.error,
              text: this.use_language.warnin_try_again_contact_it,
            })
            this.loadingExcel = 0
            this.datasetExcelShotFormat_new = []
          }



        },

        async get_data_order_excel_new_shot_format (limits, offsets) {
          let response = await axios.post(orderService_dotnet+'Order/get-order-export-to-excel-shot-format',{
            "shopID":  this.ShopID,
            "shippingStatusID": this.dialog_excel_select,
            "dateFrom": this.startDate +  ' ' + this.time1,
            "dateTo": this.endDate + ' ' + this.time2,
            "limits" : limits ,
            "offsets" : offsets
          } , { headers: this.header_token})
          if(response.data.length > 0){
            return response.data
          } else {
            return []
          }

        },


        dialog_export_excel () {
          this.dialog_excel = true
          this.ExcelType = false
          this.startDate = new Date().toISOString().substr(0, 10)
          this.endDate = new Date().toISOString().substr(0, 10)
        },

        async inv_pre_print(){
          if (this.selected_order.length > 0) {
            try {
              var order_list = []
              for (var o = 0; o < this.selected_order.length; o++) {
                order_list.push(this.selected_order[o]['id'])
              }
              let response = await axios.post(reportService_dotnet+'ShopInvoiceOrder/get-invoice-no-before-print', {
                "orderList":order_list,
                "ShopID":  this.ShopID
              },
              { headers: this.header_token})

              this.invoice_print.invorder = []
              for (var i=0; i<response.data.length; i++ ) {

                var splitedText=response.data[i]['dateString'].split('-')
                this.invoice_print.invorder.push(
                  {
                    "orderId":response.data[i]['orderMasterID'],
                    "invoiceNo":response.data[i]['invoiceNo'],
                    "dateString":response.data[i]['dateString'],
                    "date": splitedText[2]+'-'+splitedText[1]+'-'+splitedText[0],
                      "startDateMenu":false,

                  })
              }
              this.inv_dialog_printinvoice = true
            } catch (error) {
              this.$swal({
                type: 'success',
                title: this.use_language.done,
              })
            }
          }
          else{
            this.$swal({
              type: 'warning',
              title: this.use_language.please_select_order_to_proceed,
            })
          }
        },

        set_zero (val) {
          val = val.toString()
          if(val < 10){
            return "0"+val
          }
          return val
        },

        async inv_printinvoice(){
          if(this.invoice_print.titleprint_main == null || this.invoice_print.titleprint_main.length == 0){
            this.$refs.refinvtitleprintmain.focus()
            return
          }

          if(this.invoice_print.invorder.length == 0){
            return
          }
          if(this.invoice_print.titleprint_secondary != null){
            if(this.invoice_print.titleprint_secondary.length == 0 ){
              this.invoice_print.titleprint_secondary = null
            }
          }


          const today = new Date();
          const date = today.getFullYear()+'-'+(this.set_zero(today.getMonth()+1))+'-'+this.set_zero(today.getDate());
          this.invoice_print.date = date


          if(this.invoice_print.titleprint_secondary == null){
              this.invoice_print.titleprint_secondary = {'text':null,'value':null}
            }
          localStorage.setItem('INVPrint',  JSON.stringify(this.invoice_print))
          localStorage.setItem('Sizepage',  this.sizepage)
          window.open('/print-tax-invoice');
          this.clear_printinvoice()
          this.inv_dialog_printinvoice = false

        },

        cover_pages(){
          if (this.selected_order.length > 0) {
            for (var i=0; i<this.selected_order.length; i++ ) {
              this.coverpages_print.OrderID.push({"OrderId":this.selected_order[i]['id']})
            }
            this.dialog_printcoverpage = true
          }
          else{
            this.$swal({
              type: 'warning',
              title: this.use_language.please_select_order_to_proceed,
            })
          }
        },

        async get_authorize_staffshop () {
          this.authorize = this.checkAuthorize(24);
          // if(localStorage.getItem("320") == 2)
          // {
          //  this.authorize = true
          // }
        },
        async getShopChannel(){
          let res1 = await axios.get(orderService_dotnet+'Order/get-shop-all-channel?ShopID='+this.ShopID,
                { headers: this.header_token});
          this.channelList = res1.data.items;

        },
        printcoverpage(){
          localStorage.setItem('Print_Coverpage',  JSON.stringify(this.coverpages_print))
          window.open('/print-cover-pages');
          this.clear_printcoverpage()
          this.dialog_printcoverpage = false
        },

        clear_printinvoice(){
          this.invoice_print = {
            "ShopID" : this.ShopID,
            "printorder":[{"invorder": [],
                      "titleprint_main": [],
                      "titleprint_secondary": [],
                      "date": new Date().toISOString().substr(0, 10)
          }]
          }
        },

        remove_data_invoice (index) {
          this.invoice_print.invorder.splice(index, 1);
        },

        clear_printcoverpage(){
          this.coverpages_print = {
              sizepage: "a4",
            // templateorderpage:[],
            ShopID: this.ShopID,
            OrderID:[]
          }
        }, 
        }
    }
</script>
<style scoped>
    /* >>>.v-dialog {
        -webkit-box-shadow: none;
        box-shadow: none;
    } */

    >>>.bex48-logo {
        width: 12.533vw;
        height: 11.2vw;
        display: block;
        /* margin: 8.8vw auto 1.6vw; */
        margin: 1.6vw auto 1.6vw;
    }

    >>>.slide-fade-enter-active {
      transition: all .3s ease;
    }
    >>>.slide-fade-leave-active {
      transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    >>>.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateY(10px);
      opacity: 0;
    }

    .packhai-border-table{
      border:1px solid rgba(0, 0, 0, 0.12);
      border-radius:4px;
    }
    .packhai-border-table thead{
      color:white;
    }
    .packhai-border-table thead tr th{

      font-weight: bold;
      font-size: 1rem;
    }
    .return-order-table{
      width: 100%;
    }
    .padding-for-order-dialog{
      padding: 0px !important ;
    }
    @media screen and (min-width: 768px) {
      .return-order-table {
        width: 300px;
      }

      .padding-for-order-dialog{
        padding: 15px !important;
      }
    }

    .packhai-border-preview {
      border-top: solid 1px black;
      border-left: solid 1px black;
      border-right: solid 1px black;
      border-bottom: solid 1px black;
      border-radius: 10px ;
    }

    .px-15{
      padding-left: 15px;
      padding-right:  15px;
    }

    .fz-12{
      font-size: 12px !important;
    }

    .fz-14{
      font-size: 14px !important;
    }

</style>
